export { default } from 'components/Pages/ErrorNotFound';
